import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onBeforeUnmount, computed, ref, watch, nextTick } from 'vue';
import { useDeveloperCheck } from '@/utils/useDeveloperCheck';
import { useOnScreenDebugger } from '@/composables/useOnScreenDebugger';
import { useVideoDebugStore } from '@/store/video-debug';
import OnScreenDebuggerVideoTab from './OnScreenDebuggerVideoTab.vue';
import OnScreenDebuggerGeneralTab from './OnScreenDebuggerGeneralTab.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OnScreenDebugger',
  setup(__props, { expose: __expose }) {
  __expose();

const { isDeveloper, fetchDeveloperIds } = useDeveloperCheck();
const debuggerApi = useOnScreenDebugger(isDeveloper);
const videoDebugStore = useVideoDebugStore();

const contentRef = ref<HTMLElement | null>(null);

const panelExpanded = computed(() => debuggerApi.panelExpanded.value);
const paused = computed(() => debuggerApi.paused.value);
const activeTab = computed(() => debuggerApi.activeTab.value);
const consoleLogs = computed(() => debuggerApi.consoleLogs.value);
const networkLogs = computed(() => debuggerApi.networkLogs.value);
const consoleCount = computed(() => debuggerApi.consoleCount.value);
const networkCount = computed(() => debuggerApi.networkCount.value);

const videoTabHasData = computed(
  () =>
    !!videoDebugStore.manifestUrl.value ||
    !!videoDebugStore.playbackInfo.value ||
    !!videoDebugStore.deviceCapabilities.value,
);

function scrollToBottom() {
  nextTick(() => {
    const el = contentRef.value;
    if (el) el.scrollTop = el.scrollHeight;
  });
}

watch([consoleLogs, networkLogs], () => scrollToBottom(), { deep: true });
watch(activeTab, () => scrollToBottom());

function showConsoleTab() {
  debuggerApi.showConsoleTab();
}
function showNetworkTab() {
  debuggerApi.showNetworkTab();
}
function showVideoTab() {
  debuggerApi.showVideoTab();
}
function showGeneralTab() {
  debuggerApi.showGeneralTab();
}

function isFailedRequest(entry: { status: number | string }): boolean {
  const s = entry.status;
  if (s === 'ERR' || s === 0) return true;
  const n = Number(s);
  return !Number.isNaN(n) && n >= 400;
}

function handleKeyDown(event: KeyboardEvent) {
  if (!isDeveloper.value) return;
  const key = event.key;
  const code = event.keyCode;
  if (key === '0' || code === 48) {
    event.preventDefault();
    event.stopPropagation();
    debuggerApi.clearAll();
    return;
  }
  if (key === '1' || code === 49) {
    event.preventDefault();
    event.stopPropagation();
    debuggerApi.togglePanel();
    return;
  }
  if (key === '2' || code === 50) {
    event.preventDefault();
    event.stopPropagation();
    debuggerApi.showConsoleTab();
    return;
  }
  if (key === '3' || code === 51) {
    event.preventDefault();
    event.stopPropagation();
    debuggerApi.showNetworkTab();
    return;
  }
  if (key === '4' || code === 52) {
    event.preventDefault();
    event.stopPropagation();
    debuggerApi.togglePause();
    return;
  }
  if (key === '5' || code === 53) {
    event.preventDefault();
    event.stopPropagation();
    debuggerApi.showVideoTab();
    return;
  }
  if (key === '6' || code === 54) {
    event.preventDefault();
    event.stopPropagation();
    debuggerApi.showGeneralTab();
    return;
  }
}

onMounted(() => {
  fetchDeveloperIds();
  document.addEventListener('keydown', handleKeyDown, true);
});

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown, true);
  debuggerApi.closeDebugger();
});

const __returned__ = { isDeveloper, fetchDeveloperIds, debuggerApi, videoDebugStore, contentRef, panelExpanded, paused, activeTab, consoleLogs, networkLogs, consoleCount, networkCount, videoTabHasData, scrollToBottom, showConsoleTab, showNetworkTab, showVideoTab, showGeneralTab, isFailedRequest, handleKeyDown, OnScreenDebuggerVideoTab, OnScreenDebuggerGeneralTab }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})